import React from 'react'
import FeaturesSliderItems from "./FearturesSliderItems"
export default function FeaturesSlider() {
  return (
    <div>
      <section className="section03 bg-map">
        <div className="container-fluid">
            <FeaturesSliderItems />
        </div>
      </section>
    </div>
  )
}
